export default {
  // get rtc peer connection server
  getRTCServer(evt) {
    const iceCandidates = {
      relay: 'TURN',
      srflx: 'STUN',
      prflx: 'STUN',
      host: 'Host'
    }

    const candidate = evt.candidate
      ? evt.candidate.split("typ")[1].split(" ")[1] // Firefox: parse candidate info after `typ` string
      : evt.type

    return iceCandidates[candidate] || candidate;
  }
}

